import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import languages from 'helpers/languages';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';

const StyledError = styled.div`
    margin: 10px 0 0 30px;
    font-size: 14px;
    line-height: 20px;
    color: ${ theme.palette.redOrange };
    font-style: italic;
`;

const LocalisationErrors = (props) => {
    if (!props.submitFailed) {
        return (
            <div style={ { height: '50px' } }></div>
        );
    }

    const {
        fields,
        formValues,
        localeLabel,
        translate,
    } = props;

    let errors = {};

    utils.each(fields, (field) => {
        const { name } = field;

        if (!utils.has(formValues, name) || utils.get(formValues, name) === '') {
            const translation = translate('forms.submit.required', {
                locale: translate(`languages.${ localeLabel.toLowerCase() }`),
                key: name,
            });

            errors[name] = translation;
        }
    });

    return (
        <div style={ { height: '50px' } }>
            {
                utils.map(errors, function (error) {
                    return (
                        <StyledError key={ error }>{ error }</StyledError>
                    );
                })
            }
        </div>
    );
};

LocalisationErrors.propTypes = {
    fields: PropTypes.array,
    formValues: PropTypes.object,
    localeLabel: PropTypes.string,
    submitFailed: PropTypes.bool,
    translate: PropTypes.func,
};

function mapStateToProps(state, props) {
    const {
        baseLocale,
        form,
    } = props;

    const selector = formValueSelector(form);

    return {
        localeLabel: languages.getLabel(baseLocale),
        formValues: selector(state, baseLocale),
    };
}

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        {},
    ),
    reduxForm(),
);

export default enhance(LocalisationErrors);



// WEBPACK FOOTER //
// ./src/components/form/localisation/LocalisationErrors.js